import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Auth0Provider } from '@auth0/auth0-react';

const auth0Config = {
  domain: import.meta.env.REACT_APP_AUTH0_DOMAIN!,
  clientId: import.meta.env.REACT_APP_AUTH0_CLIENT_ID!,
  authorizationParams: {
    // Always come back to the address the login started on. The login's state is saved per
    // address, so returning anywhere else (Cloud Run has two addresses, plus a custom domain)
    // fails with "Invalid state". Each address's /callback must be allowed in Auth0.
    redirect_uri: `${window.location.origin}/callback`,
    // Access tokens are issued for this API; the backend rejects tokens for any other audience
    audience: import.meta.env.REACT_APP_AUTH0_AUDIENCE,
  },
  cacheLocation: 'localstorage' as const,
  useRefreshTokens: true,
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Check if Auth0 is properly configured
const isAuth0Configured = 
  import.meta.env.REACT_APP_AUTH0_DOMAIN && 
  import.meta.env.REACT_APP_AUTH0_CLIENT_ID &&
  !import.meta.env.REACT_APP_AUTH0_CLIENT_ID.includes('your-auth0-client-id') &&
  !import.meta.env.REACT_APP_AUTH0_CLIENT_ID.includes('placeholder');

// App provides its own AuthProvider inside the router and query cache
root.render(
  <React.StrictMode>
    {isAuth0Configured ? (
      <Auth0Provider {...auth0Config}>
        <App />
      </Auth0Provider>
    ) : (
      <App />
    )}
  </React.StrictMode>
);
